import React, {useEffect, useState} from 'react';
import backgroundHome from "../photo/backgroundHomePage3small.jpg";
import HomeButtons from "../components/HomeButtons";
/*
SmartLuggage Application
Marek Augustyn
6.08.2023
*/

const HomeV2 = () => {

    return (
        <div id="homePage" className="container-fluid"
             style={{
                 backgroundImage: `url(${backgroundHome})`, backgroundRepeat: 'repeat-no',
                 backgroundSize: "cover", opacity: 0.98,
             }}
        >

            <HomeButtons/>
        </div>

    );

}

export default HomeV2;